// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { StorageDumpSiteDumpsterLink } from './storage-dump-site-dumpster-link';
import { TonExpense } from './ton-expense';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class StorageDumpSite extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get fullAddress() {
      return [this.address1, this.address2, this.city ? this.city + ',' : null, this.state, this.zip, this.country].join(' ');
  }
  get displayAddress() {
    return [this.address1, this.address2, this.city + ',', this.state, this.zip, this.country].join(' ');
  }
  get displayDumpsters() {
    return this.dumpsters.filter(x => x.deleted == null).map(x => x.dumpster.size).join(', ');
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  address1?: string;
  address2?: string;
  city?: string;
  country?: string;
  county?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  displayOrder?: number;
  dump!: boolean;
  latitude?: number;
  longitude?: number;
  name?: string;
  note?: string;
  state?: string;
  storage!: boolean;
  tonExpenseId?: number;
  zip?: string;
  dumpsters!: StorageDumpSiteDumpsterLink[];
  tonExpense!: TonExpense;
}

